angular.module('tradersyard').factory('InviteManagerFactory', [
    '$rootScope',
    'graph-invite-factory',
    'WebSocket',
    '$timeout',
    function ($scope, ApiInviteFactory, WebSocket, $timeout) {
        var Manager = {};

        function Instance(id, entry) {
            var instance = this;

            instance.Id = id;
            instance.Entry = entry;
            instance.Count = undefined;
            instance.Guid = [];
            instance.Data = [];
            instance.Let = 0;
            instance.Lock = 0;
            instance.Page = 0;
            instance.Status = 'pending';
            instance.Glue = true;

            function Sucess(response, action) {
                if (response.data.state === 0) {
                    switch (action) {
                        case 'Query':
                            return response.data.data.length > 0;

                        default:
                            return true;
                    }
                } else {
                    return false;
                }
            }

            instance.Add = function (invite) {
                ++instance.Let;
                instance.Data.unshift(invite);

                if (instance.Count !== undefined) ++instance.Count;

                return instance;
            };

            instance.Del = function (id) {
                --instance.Let;

                angular.forEach(instance.Data, function (request, i) {
                    if (parseInt(request.id) === parseInt(id)) {
                        instance.Data.splice(i, 1);

                        if (instance.Count !== undefined) --instance.Count;
                    }
                });
            };

            instance.Concat = function (data) {
                instance.Data = data.concat(instance.Data);

                return instance;
            };

            instance.Digest = function () {
                if (!$scope.$$phase) {
                    $scope.$digest();
                }

                return instance;
            };

            instance.Query = function (next) {
                if (instance.Lock === 0) {
                    instance.Lock = 1;
                    ++instance.Page;

                    ApiInviteFactory.entry(instance.Entry, instance.Id)
                        .query({
                            params: {
                                limit: 25,
                                page: instance.Page,
                                status: instance.Status,
                                let: instance.Let,
                            },
                        })
                        .then(function (response) {
                            if (Sucess(response, 'Query') === true) {
                                instance.Concat(response.data.data);

                                instance.Lock = 0;

                                instance.Digest();
                            }

                            if (next) next();

                            return instance;
                        });
                }
            };

            instance.Create = function (id, entry, guid, call) {
                instance.Guid.push('C-' + guid);

                instance.Glue = false;

                ApiInviteFactory.entry(entry, id)
                    .create({
                        headers: {
                            'X-Ph-Guid': 'C-' + guid,
                        },
                    })
                    .then(function (response) {
                        if (Sucess(response) === true) {
                            instance.Add(response.data.data);

                            instance.Glue = true;

                            if (call) call();

                            instance.Digest();
                        }

                        return instance;
                    });
            };

            instance.Accept = function (id, guid, call) {
                instance.Guid.push('A-' + guid);

                ApiInviteFactory.entry(instance.Entry, instance.Id)
                    .accept(id, {
                        headers: {
                            'X-Ph-Guid': 'A-' + guid,
                        },
                    })
                    .then(function (response) {
                        if (Sucess(response) === true) {
                            instance.Del(id);

                            if (call) call();

                            instance.Digest();
                        }

                        return instance;
                    });
            };

            instance.Reject = function (id, guid, call) {
                instance.Guid.push('R-' + guid);

                ApiInviteFactory.entry(instance.Entry, instance.Id)
                    .reject(id, {
                        headers: {
                            'X-Ph-Guid': 'R-' + guid,
                        },
                    })
                    .then(function (response) {
                        if (Sucess(response) === true) {
                            instance.Del(id);

                            if (call) call();

                            instance.Digest();
                        }

                        return instance;
                    });
            };

            instance.Cast = (function (instance) {
                var cast = this;

                cast.Create = function (request) {
                    //

                    instance.Digest();
                };

                cast.Accept = function () {
                    //

                    instance.Digest();
                };

                cast.Reject = function () {
                    //

                    instance.Digest();
                };

                // bind socket listener
            })(instance);

            WebSocket.on('invite:create', function (data) {
                if (instance.Entry === 'user' && parseInt(data.node.user.id) === parseInt(instance.Id)) {
                    var index = instance.Guid.indexOf(data.guid);

                    if (index === -1) {
                        instance.Add(data.node);
                        instance.Digest();
                    } else {
                        instance.Guid.splice(index, 1);
                        if (instance.Count !== undefined) {
                            ++instance.Count;
                        }
                    }
                }
            });

            WebSocket.on('invite:accept', function (data) {
                if (instance.Entry === 'user' && parseInt(data.node.user.id) === parseInt(instance.Id)) {
                    angular.forEach(instance.Data, function (message, i) {
                        if (parseInt(message.id) === parseInt(data.node.id)) {
                            var index = instance.Guid.indexOf(data.guid);

                            if (index !== -1) {
                                instance.Guid.splice(index, 1);
                                instance.Data.splice(i, 1);
                            }
                        }
                    });

                    if (instance.Count !== undefined) {
                        --instance.Count;
                    }
                }
            });

            WebSocket.on('invite:reject', function (data) {
                if (instance.Entry === 'user' && parseInt(data.node.user.id) === parseInt(instance.Id)) {
                    angular.forEach(instance.Data, function (message, i) {
                        if (parseInt(message.id) === parseInt(data.node.id)) {
                            var index = instance.Guid.indexOf(data.guid);

                            if (index !== -1) {
                                instance.Guid.splice(index, 1);
                                instance.Data.splice(i, 1);
                            }
                        }
                    });

                    if (instance.Count !== undefined) {
                        --instance.Count;
                    }
                }
            });
        }

        function Encode(id, entry) {
            return [entry ? entry : 'user', id].join(':');
        }

        function Get(id, entry, $scope) {
            var room = Encode(id, entry);
            var data = Manager[room];

            if (data === undefined) {
                Manager[room] = new Instance(id, entry ? entry : 'user', $scope);

                Manager[room].Query();
            }

            return Manager[room];
        }

        function Init(id, entry, $scope) {
            var room = Encode(id, entry);
            var data = Manager[room];

            if (data === undefined) {
                Manager[room] = new Instance(id, entry ? entry : 'user', $scope);
            }

            return Manager[room];
        }

        return {
            Get: Get,
            Init: Init,
        };
    },
]);
